// extracted by mini-css-extract-plugin
module.exports = {"section8":"Section8_section8__5EGBc"};